<template>
    <div class="layout__width-100">
        <div class="text__align-center text__colour-white layout__margin__bottom-25px colour__background__grey-f7f8fa">
            <div class="layout__padding-clear layout__width-80 layout__padding-40px-0">
                <div class="text__colour-teal text__size-50 text__style-bold-700">Price List</div>
            </div>
        </div>

        <div>


            <div>
            </div>

        </div>

    </div>

</template>

<script>

    // import fancyBox from 'vue-fancybox';

    export default {
        name: "Digital",
        components: {
            // pdf
        },
        data() {
            return {}
        },
        created() {
        },
        methods: {
            // open (e) {
            //     fancyBox(e.target, this.imageList);
            // }
        }
    };
</script>